import {
  GET_ENTITLEMENTS_ENABLEMENTS_API,
  GET_INDIVIDUAL_ENABLEMENTS_API,
} from 'config/constants';
import axios from 'axios';
import { UserEntitlement } from 'types/user';

const { get } = axios;

/**
 *  Returns all processed enablement data (quotas, configurations,
 *  and features) for the user's current entitlements in a single object.
 *  A unified endpoint for all calculated enablement limits and settings.
 *  @return {Promise<UserEntitlement>} A promise containing user enablement data
 */
export const getEntitlementEnablements = async () => {
  try {
    const response = await get<UserEntitlement>(
      GET_ENTITLEMENTS_ENABLEMENTS_API,
    );
    return response.data;
  } catch (e) {
    throw e;
  }
};

/**
 *  Enablement data (features, configurations, and quotas) for each
 *  active subscription or alacarte entitlement.
 *  @return {Promise<UserEntitlement>} A promise containing user enablement data
 */
export const getIndividualEnablements = async (): Promise<{
  [key: string]: UserEntitlement;
}> => {
  try {
    const response = await get<{ [key: string]: UserEntitlement }>(
      GET_INDIVIDUAL_ENABLEMENTS_API,
    );
    return response.data;
  } catch (e) {
    throw e;
  }
};
